import React, { ReactNode } from 'react';
export interface TextValueProps {
  value: TextProps
  children?: ReactNode
}
interface TextProps {
  className?: string;
  injectedChildren?: ReactNode;
}
const Text: React.FC<TextValueProps> = ({children, value}) => {
  const { className, injectedChildren } = value;

  return <p className={`${className}`}>{children ?? injectedChildren}</p>;
};
export default Text;